if (!customElements.get('rr-size-guide')) {
  customElements.define('rr-size-guide', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.root = this.closest('product-info');
      this.onOpen = event => {
        const opener = event.target.closest('[data-rr-size-guide-open]');
        if (!opener || !this.root.contains(opener)) return;
        event.preventDefault();
        if (this.dialog.open) return;
        this.opener = opener;
        this.querySelector('input[value="in"]').checked = true;
        this.updateUnits('in');
        this.dialog.showModal();
        this.dialog.scrollTop = 0;
        document.body.classList.add('rr-size-guide-open');
      };
      this.onClick = event => {
        if (event.target.closest('[data-rr-size-guide-close]')) this.dialog.close();
        if (event.target === this.dialog) {
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }
      };
      this.onChange = event => {
        if (event.target.matches('.rr-size-guide__units input')) this.updateUnits(event.target.value);
      };
      this.onClose = () => {
        document.body.classList.remove('rr-size-guide-open');
        if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
      };
      this.root?.addEventListener('click', this.onOpen);
      this.dialog.addEventListener('click', this.onClick);
      this.dialog.addEventListener('change', this.onChange);
      this.dialog.addEventListener('close', this.onClose);
    }
    updateUnits(unit) {
      this.querySelectorAll('[data-inches]').forEach(cell => {
        cell.textContent = unit === 'cm' ? String(Math.round(Number(cell.dataset.inches) * 254) / 100) : cell.dataset.inches;
      });
      this.querySelectorAll('[data-rr-size-unit-label]').forEach(label => { label.textContent = unit === 'cm' ? '(cm)' : '(in)'; });
      const caption = this.querySelector('[data-rr-size-unit-caption]');
      caption.textContent = caption.dataset[unit === 'cm' ? 'cm' : 'in'];
    }
    disconnectedCallback() {
      this.root?.removeEventListener('click', this.onOpen);
      this.dialog?.removeEventListener('click', this.onClick);
      this.dialog?.removeEventListener('change', this.onChange);
      this.dialog?.removeEventListener('close', this.onClose);
      if (this.dialog?.open) {
        this.dialog.close();
        document.body.classList.remove('rr-size-guide-open');
      }
    }
  });
}
